import { diContainer, serviceNames } from './service-setup/diContainer';

import { setupServiceInfo } from '@estee/elc-universal-utils';

diContainer.get(serviceNames.orderHistoryService).register();

setupServiceInfo(__serviceInfo__);
